export default function RepresentativeCell({ value }: { value: string }) {
    return (
        <div
            className={` ${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} flex min-w-[100px] flex-col items-center justify-center text-center`}
        >
            <span>Representative</span>
            <span>{value}</span>
        </div>
    );
}
